import { useEffect } from "react";
import { img } from "./api";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, canonical, robots, ogTitle, ogDescription, ogImage, jsonLd }, deps = []) {
  useEffect(() => {
    const full = title ? (title.includes("Bhatkya") ? title : `${title} | Bhatkya`) : "Bhatkya - भटक्या | Adventure Travel";
    document.title = full;
    setMeta("name", "description", description);
    setMeta("name", "robots", robots || "index,follow");
    setMeta("property", "og:title", ogTitle || full);
    setMeta("property", "og:description", ogDescription || description);
    const ogi = ogImage ? (ogImage.startsWith("http") ? ogImage : window.location.origin + (ogImage.startsWith("/api") ? img(ogImage).replace(window.location.origin, "") : ogImage)) : "";
    setMeta("property", "og:image", ogi);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", window.location.href);
    setMeta("name", "twitter:card", "summary_large_image");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = canonical || window.location.origin + (window.location.pathname.replace(/\/+$/, "") || "/");
    document.head.querySelectorAll("script[data-jsonld]").forEach((s) => s.remove());
    (jsonLd ? [].concat(jsonLd) : []).filter(Boolean).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.dataset.jsonld = "1";
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: window.location.origin + it.to })),
});

export function pageSeo(site, key, fallback = {}) {
  const s = site?.seo?.[key] || {};
  return {
    title: s.meta_title || fallback.title,
    description: s.meta_description || fallback.description,
    canonical: s.canonical || undefined,
    robots: s.robots,
    ogTitle: s.og_title,
    ogDescription: s.og_description,
    ogImage: s.og_image || fallback.ogImage,
  };
}
